<div #overlay class="confirm-overlay" [ngStyle]="style">
  <div class="confirm-content center-content">
    <div class="center-content column-flex" [class.small]="smallDialog">
      <div class="main-container">
        <div class="text-container center-content">
          <mat-icon svgIcon="save-error" class="error-icon" *ngIf="errorIcon" />
          <div class="main-label" data-cy="confirmation-window-header">
            {{ mainLabel | translate: { title } }}
          </div>
          <ng-container *ngIf="subLabel">
            <div class="sub-label" data-cy="confirmation-window-body">
              {{ subLabel | translate }}
            </div>
          </ng-container>
        </div>

        <div class="comment-container" *ngIf="comment !== undefined && comment !== null">
          <app-textarea-with-error
            class="input-form"
            [inputValue]="comment"
            [legend]="'approval.request.dialog.reason.form.comment'"
            [propertyName]="'comment'"
            (onInputUpdated)="onCommentUpdated($event)"
            [rows]="9"
            [maxLength]="maxLength"
          ></app-textarea-with-error>
        </div>
      </div>

      <div class="button-container">
        <ng-container *ngIf="goBackLabel">
          <button
            data-cy="confirmation-window-back-to-page-button"
            (click)="goBack()"
            [ngClass]="{
              save: inverseColors,
              noPadding: !inverseColors,
              'folder-delete-cancel': variant === 'folder-delete',
            }">
            {{ goBackLabel | translate }}
          </button>
        </ng-container>

        <ng-container *ngIf="!goBackLabel && !allButtonsLeft">
          <div>
            <button (click)="discardChanges()">
              {{ discardLabel | translate }}
            </button>
          </div>
        </ng-container>
        <div class="left-buttons">
          <div *ngIf="goBackLabel || allButtonsLeft">
            <button
              class="discard"
              data-cy="confirmation-window-discard-button"
              (click)="discardChanges()"
              [ngClass]="{
                cancel: allButtonsLeft && !goBackLabel && !inverseColors,
                save: allButtonsLeft && inverseColors,
                'extra-padding': allButtonsLeft,
              }">
              {{ discardLabel | translate }}
            </button>
          </div>

          <button
            class="extra-padding"
            data-cy="confirmation-window-confirm-button"
            (click)="saveChanges()"
            [ngClass]="{
              save: !inverseColors,
              disabledStyle: saveIsDisabled,
              discard: allButtonsLeft,
              'folder-delete-confirm': variant === 'folder-delete',
            }">
            {{ saveLabel | translate }}
          </button>

          <ng-container *ngIf="thirdLabel">
            <button
              class="extra-padding"
              data-cy="confirmation-window-third-button"
              (click)="thirdButtonClick()"
              [ngClass]="{
                'folder-delete-confirm': variant === 'folder-delete',
              }">
              {{ thirdLabel | translate }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
